<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs">
        <use href="assets/icons-ui.svg#cross-closed"></use>
    </svg>
</button>
<h2 modal-title>Gegevens <ins-involved-role [role]="data.role"></ins-involved-role></h2>
<div modal-content>
    <div class="add-party-modal">
        <ins-add-party-container
            (closed)="onCancel()"
            *ngIf="data.showContent"
            [fileSerialNumber]="data.fileSerialNumber"
            [relationId]="data.relationId"
            [role]="data.role"
        ></ins-add-party-container>
    </div>
</div>
